<template>
  <div class="">
    <div class="mgb80">
      <div class="content-web">
        <div class="inner_content_right">
          <div class="wp_single wp_column_article">
            <div class="wp_entry">
              <div class="wp_articlecontent">
                <div class="head">
                  <div><img src="@/assets/images/tjtcLTD.jpg" alt="" /></div>
                  <div class="con">
                    <p>
                      “把自己人变成能人，把能人变成自己人”。津旅集团始终坚持把人才队伍建设作为企业发展的首要任务，尊重、关爱员工。集团重视对人才的培训与培养，着力营造有利于人才成长和发展的工作环境，给想干事的人搭平台，给能干事的人搭舞台，给后备人才搭阶梯。通过实施“引人、用人、育人”的人才战略，津旅集团聚集并培养了一大批优秀的各类专业人才，依靠团队力量，实现快速健康发展。我们期待您到集团来贡献自己、发现自己、超越自己。
                    </p>
                    <div class="ltd">
                      <img
                        src="@/assets/images/pxfz.jpg"
                        alt=""
                        width="300px"
                      />
                    </div>
                  </div>
                </div>
                <div class="foot">
                  <div class="foot-title">培训发展</div>
                  <div class="foot-con">
                    <p class="p1">
                      “津旅集团坚持企业与员工共同发展的理念，充分利用各类资源和条件为员工创造学习与成长机会，为集团的快速、健康、可持续发展培养了一批高层次人才和业务骨干。
                    </p>
                    <p>
                      1、入职培训:
                      使新员工尽快熟悉企业文化，融入团队、适应岗位要求。
                    </p>
                    <p>
                      2、岗位技能培训:提供与目前岗位相关的知识和技能培训，提高员工适应能力和工作效率。
                    </p>
                    <p>
                      3、职业素养培训：进行职业行为规范和职业道德教育，提高员工个人修养和职业素养。
                    </p>
                    <p>
                      4、管理能力培训：根据管理人员专业背景、工作需要与未来发展，组织针对性培训课程，提升综合管理能力。
                    </p>
                    <p>
                      5、专项培训：根据集团年度工作计划与经营目标、国内外宏观经济形势、政策法规等举办各类专项培训，开拓视野，确保工作目标实现。
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "",
  components: {},
  props: {},
  data() {
    return {};
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  beforeDestroy() {},
  methods: {},
};
</script>
<style lang='scss' scoped>
.mgb80 {
  margin-bottom: 80px;
  margin-top: 30px;
  .foot {
    margin-top: 20px;
    line-height: 2em !important;
    font-size: 14px !important;
    font-family: "宋体" !important;
    .foot-title {
      color: #0070c0;
      font-weight: 800;
    }
    .foot-con {
      .p1 {
        margin: 30px 0;
      }
      p {
        text-indent: 30px;
        color: #696969;
      }
    }
  }
  .content-web {
    .con {
      display: flex;
      p {
        margin-top: 55px;
        text-indent: 30px;
      }
    }
    display: flex;
    width: 100%;
    margin: 0 auto;
    .inner_content_right {
      .wp_single.wp_column_article {
        padding: 48px 40px 100px 40px;
      }
      .wp_entry {
        line-height: 2em !important;
        font-size: 14px !important;
        font-family: "宋体" !important;
        width: 100%;
        line-height: 1.7em;
        font-size: 13px;
        color: #333;
        overflow: hidden;;
        .head {
          border-bottom: 1px #444 dashed;
          height: 400px;
        }
      }
      .text {
        text-indent: 45px;
      }
      .ltd {
        float: right;
      }
    }
  }
}
</style>